/**
 * ISO helpers built around Opta's split `matchInfo.date` and `matchInfo.time`.
 */

/**
 * Combines Opta's `matchInfo.date` and `matchInfo.time` into a single UTC
 * ISO string (e.g. `"2026-06-14T18:00:00Z"`).
 *
 * The trailing `Z` is essential — without it `new Date()` parses the string
 * as local time. Opta sometimes includes `Z` on `time` too, so both parts
 * are stripped before re-assembling to guarantee exactly one.
 *
 * @param {{ date: string, time: string } | null | undefined} matchInfo
 * @returns {string | undefined}
 */
export const getMatchISODate = (matchInfo) => {
  if (!matchInfo) return undefined;
  const datePart = matchInfo.date.replace(/Z$/, '');
  const timePart = matchInfo.time.replace(/Z$/, '');
  return `${datePart}T${timePart}Z`;
};

/**
 * `"MM-DD"` slug from `matchInfo.date`.
 * @param {{ date: string }} matchInfo
 * @returns {string}
 */
export const dateSlug = ({ date }) => {
  const [, month = '', day = ''] = date.replace(/Z$/, '').split('-');
  return `${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
